import {
  ExpandableText,
  ExpandableTextProps,
} from '@awaze/design-system.components.expandable-text'
import { HeadlineProps } from '@awaze/design-system.components.text'
import { Document } from '@contentful/rich-text-types'
import { useIntl } from 'react-intl'

import RichText from '@/components/RichText/RichText'

export interface ExpandableTextModuleProps
  extends Omit<Omit<ExpandableTextProps, 'text'>, 'heading'> {
  heading: HeadlineProps
  headingText: string
  text: Document
  textColor?: 'light' | 'dark'
}

export const ExpandableTextModule: React.FC<ExpandableTextModuleProps> = ({
  text,
  textColor,
  ...props
}) => {
  const { formatMessage } = useIntl()

  return (
    <ExpandableText
      {...props}
      heading={{ text: props.headingText, ...props.heading }}
      headers={{
        collapse: formatMessage({
          id: 'expandable-text.read-less',
          defaultMessage: 'Read less',
        }),
        expand: formatMessage({
          id: 'expandable-text.read-more',
          defaultMessage: 'Read more',
        }),
      }}
      text={{
        text: (
          <RichText
            content={text}
            textColor={
              textColor === 'light'
                ? 'ColorTextBodyOnDark'
                : 'ColorTextBodyOnWhite'
            }
          />
        ),
      }}
    />
  )
}
